import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ItemProdutoDetalharComponent } from "./item-produto-detalhar.component";
import { ItemProdutoDetalharRoutingModule } from "./item-produto-detalhar-routing.module";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { FormsModule } from "@angular/forms";
import { TableModule } from "primeng/table";
import { InputMaskModule } from "primeng/inputmask";
import { FormatPipeModule } from "src/app/admihair/format-pipe/format-pipe.module";
import { TabViewModule } from "primeng/tabview";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { MessagesModule } from "primeng/messages";
import { QRCodeModule } from 'angularx-qrcode';
import { TooltipModule } from "primeng/tooltip";
import { DialogModule } from "primeng/dialog";
import { DividerModule } from "primeng/divider";
import { InputNumberModule } from "primeng/inputnumber";


@NgModule({
    imports: [
        CommonModule,
        ItemProdutoDetalharRoutingModule,
        FormsModule,
        TableModule,
        ButtonModule,
        InputTextModule,
        InputMaskModule,
        FormatPipeModule,
        TabViewModule,
        ProgressSpinnerModule,
        MessagesModule,
        QRCodeModule,
        TooltipModule,
        DialogModule,
        DividerModule,
        InputNumberModule

    ],
    declarations: [ItemProdutoDetalharComponent]
})
export class ItemProdutoDetalharModule { }
